import { CHANGE_USER, CHANGE_USER_ERROR } from "_models/redux/types";

const initialState = {
    response: [],
    error: undefined,
    loading: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case CHANGE_USER:
            return {
                ...state,
                response: action.payload,
                loading: true,
            };

        case CHANGE_USER_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        default:
            return state;
    }
}
